import { createSvgComponent } from "../../icon/createSvgComponent";
import BenefitFill from "@core/icon/assets/benefit-fill.svg";
export default createSvgComponent(BenefitFill);